/* src/app/private/components/client-details/update-organization/update-organization.component.scss */
/*# sourceMappingURL=update-organization.component.css.map */
